const configs = {
  BASE_URL: "https://transcribe.solvitude.co.in",
  BASE_URL_AUTO: process.env.REACT_APP_APIGW_BASE_URL
    ? process.env.REACT_APP_APIGW_BASE_URL
        :"https://transcribe.solvitude.co.in"
};

export default configs;
